import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, InputGroup } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import * as api from 'service/InstallerApp/index';
import { INSTALLER_CONFIG } from 'utils/constants';
import { addError, addSuccess } from 'rdx/alert';
import './styles.scss';
import { setIsProduction } from 'rdx/hardware';

const troubleShootLink = '/hardware/installer/troubleshooting/Installation';

function InstallerConfigForm() {
  const dispatch = useDispatch();

  const [localConfig, setLocalConfig] = useState();
  const [config, setConfig] = useState();

  const getInstallerConfiguration = async () => {
    try {
      const {
        data: { config: conf },
      } = await api.getInstallerConfig();
      return JSON.parse(conf);
    } catch (err) {
      dispatch(
        addError('Unable to parse the locally stored Installer configuration', {
          selfDismiss: true,
          dismissible: true,
        }),
      );
      dispatch(addError(err.message));
    }
    return null;
  };

  useEffect(() => {
    getInstallerConfiguration().then((c) => setConfig(c));
    setLocalConfig(
      JSON.parse(
        localStorage.getItem(INSTALLER_CONFIG) ||
          '{ "port": 7777, "sslEnable": true }',
      ),
    );
  }, []);

  const onSave = async (event) => {
    event.preventDefault();
    try {
      const response = await api.saveInstallerConfig(
        JSON.stringify(config, null, 2),
      );
      dispatch(
        setIsProduction(
          JSON.parse(response?.data?.config ?? {})?.production === true,
        ),
      );
      if (response.status === 'OK') {
        dispatch(addSuccess('Updated Installer configuration successfully!'));
        setConfig(JSON.parse(response.data.config));
      } else {
        throw new Error(response.message);
      }
    } catch (e) {
      dispatch(addError(e.message));
    }
  };

  const setListeningPort = async (event) => {
    event.preventDefault();
    localStorage.setItem(INSTALLER_CONFIG, JSON.stringify(localConfig));
    setConfig(await getInstallerConfiguration());
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    let newValue;
    switch (type) {
      case 'checkbox':
        newValue = checked;
        break;
      case 'number':
        newValue = Number(value);
        break;
      default:
        newValue = value;
    }
    setConfig({ ...config, [name]: newValue });
  };

  return (
    <>
      <p>
        Alternatively, you can change Installer port and Production
        configuration values with the form below.
      </p>
      <Form className="d-flex flex-column" onSubmit={onSave}>
        {!config && (
          <Alert variant="danger">Installer not found on a given port</Alert>
        )}
        <Form.Group>
          <span>Installer port</span>
          <Form.Control
            name="Port"
            type="number"
            value={config?.Port}
            onChange={handleChange}
            disabled={!config}
          />
        </Form.Group>
        <Form.Check
          label="Use production environment"
          className="mb-3"
          type="checkbox"
          name="production"
          checked={config?.production}
          value={config?.production}
          onChange={handleChange}
          disabled={!config}
        />
        <Button
          type="submit"
          disabled={!config || !config?.Port || !String(config?.Port).length}
        >
          Save Installer Configuration Info
        </Button>
        <div>
          NB! Commands to restart (stop/start) the Installer from the terminal
          can be found <Link to={troubleShootLink}>here.</Link>
        </div>
      </Form>
      <Form inline className="mt-5" onSubmit={setListeningPort}>
        <span>Currently listening to port:</span>
        <InputGroup>
          <Form.Control
            name="port"
            type="number"
            className="listening-port ml-sm-2"
            value={localConfig?.port}
            onChange={(e) => {
              e.persist();
              setLocalConfig((lc) => ({ ...lc, port: e.target.value }));
            }}
          />
          <InputGroup.Text>
            <Button type="submit" disabled={!String(localConfig?.port).length}>
              Update
            </Button>
          </InputGroup.Text>
        </InputGroup>
      </Form>
    </>
  );
}

export default InstallerConfigForm;
